export function titleGuard(to, from, next) {
  document.title = to.meta.title ? `${to.meta.title} | StrongReader` : 'StrongReader';
  next();
}